import React, { useMemo } from 'react'
import type { PlaylistTag } from 'types/playlist'
import type { NativeTag } from 'types/track'
import { COLOR_INDICATORS } from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import type { ColorIndicator } from '@disco/utils/color-indicators'
import { COLORS } from '@disco/utils/color-indicators'
import styles from './index.module.css'

type Props = {
  tags: Partial<NativeTag & PlaylistTag>[]
}

/**
 * Color indicators display component for tags
 * Shows up to 3 colored dots representing tag colors when feature is enabled
 * @param tags - Array of tags with potential color indicators
 */
const ColorIndicators = (props: Props): null | React.ReactElement<'span'> => {
  const colorIndicatorsEnabled = useFeatureEnabled(COLOR_INDICATORS)
  const colors: ColorIndicator[] = useMemo(
    () =>
      props.tags
        .filter((tag): tag is typeof tag & { color: ColorIndicator } =>
          Boolean(tag.color),
        )
        .map(tag => tag.color)
        .slice(-3),
    [props.tags],
  )
  return colorIndicatorsEnabled && colors.length > 0 ? (
    <span className={styles.colorIndicators}>
      {colors.map((color: ColorIndicator, index: number) => (
        <span
          className={styles.colorIndicatorsItem}
          key={index}
          style={{
            background: COLORS[color],
          }}
        />
      ))}
    </span>
  ) : null
}

export default ColorIndicators
